import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import IndustriesPage from "./pages/IndustriesPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import EarlyAccessPage from "./pages/EarlyAccessPage";
import PilotPage from "./pages/PilotPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import SecurityPolicyPage from "./pages/SecurityPolicyPage";
import TermsOfServicePage from "./pages/TermsOfServicePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/industries" element={<IndustriesPage />} />
        <Route path="/how-it-works" element={<HowItWorksPage />} />
        <Route path="/early-access" element={<EarlyAccessPage />} />
        <Route path="/pilot" element={<PilotPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/security" element={<SecurityPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

